export default "__VITE_ASSET__828b950b__"